import type { ProductVendor } from "@models/product";
import { isSellable } from "./selectVendorSku";

/**
 * "Purchase from another vendor" (B-09): the offerings of the sku on screen that could back
 * its cart line instead of the one it would be bought from, cheapest first. `rows` are that
 * sku's rows only (vendorRowsForSku); sellable is isSellable's test, as for the selection.
 */
export const otherOfferings = (
    rows: ProductVendor[],
    currentId: string | undefined,
): ProductVendor[] =>
    rows
        .filter((row) => isSellable(row) && row.id !== currentId)
        .sort((a, b) => a.price - b.price);
